import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const comuni = [
  { nome: 'Colle Val d\'Elsa', pop: '~21.500', colore: '#00FF41' },
  { nome: 'Poggibonsi', pop: '~29.800', colore: '#33FF66' },
  { nome: 'San Gimignano', pop: '~7.700', colore: '#FFD700' },
  { nome: 'Casole d\'Elsa', pop: '~4.000', colore: '#FF6B6B' },
  { nome: 'Monteriggioni', pop: '~10.200', colore: '#00BFFF' },
];

const tagli = [
  { importo: 1, emoji: '', desc: 'Un caffe per il futuro', colore: '#666' },
  { importo: 2, emoji: '', desc: 'Due euro, un segnale', colore: '#888' },
  { importo: 5, emoji: '', desc: 'Una merenda solidale', colore: '#00FF41' },
  { importo: 10, emoji: '', desc: 'Un mattone digitale', colore: '#33FF66' },
  { importo: 20, emoji: '', desc: 'Una lezione di futuro', colore: '#FFD700' },
  { importo: 50, emoji: '', desc: 'Un mese di luce (letteralmente)', colore: '#FFA500' },
  { importo: 100, emoji: '', desc: 'Naming su muro dei fondatori', colore: '#FF2D2D' },
];

const CrowdfundingPage = () => {
  const [visibleSections, setVisibleSections] = useState(0);
  const [selectedTaglio, setSelectedTaglio] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setVisibleSections(prev => {
        if (prev >= 25) { clearInterval(timer); return prev; }
        return prev + 1;
      });
    }, 180);
    return () => clearInterval(timer);
  }, []);

  const fadeIn = (index) => ({
    opacity: visibleSections >= index ? 1 : 0,
    transform: visibleSections >= index ? 'translateY(0)' : 'translateY(20px)',
    transition: 'all 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
  });

  const obiettivo = 88750;
  const popTotale = 73200;

  return (
    <main data-testid="crowdfunding-page" className="min-h-screen pt-20 pb-16 bg-black text-white">
      <div className="max-w-3xl mx-auto px-6">

        {/* Header */}
        <div style={fadeIn(0)} className="text-center mb-14">
          <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-zinc-600 mb-4">
            PIANO B — CAMPAGNA CROWDFUNDING TERRITORIALE
          </p>
          <div className="w-16 h-[1px] bg-[#00FF41]/30 mx-auto mb-6" />
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black mb-3">
            La Valdelsa si Finanzia da Sola
          </h1>
          <p className="text-[#00FF41] font-mono text-sm mb-2">
            &lt;/AI_covo.tech&gt;<sup className="text-[8px]">&reg;</sup> — Hub Digitale Sociale
          </p>
          <p className="text-zinc-500 text-xs max-w-md mx-auto">
            Se le istituzioni non rispondono, rispondiamo noi.
            5 comuni, 73.200 abitanti, 1 progetto che cambia tutto.
          </p>
        </div>

        {/* L'idea in 30 secondi */}
        <div style={fadeIn(1)} className="mb-14 bg-[#0A0A0A] border border-[#00FF41]/20 p-6 sm:p-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">
            L'IDEA IN 30 SECONDI
          </p>
          <p className="text-zinc-300 text-sm leading-relaxed mb-4">
            Stiamo costruendo il primo <span className="text-white font-bold">Hub Digitale Sociale della Valdelsa</span>: 
            un luogo fisico dove chiunque — giovani, famiglie, anziani, imprese — può accedere gratuitamente a 
            formazione AI, coaching, supporto psicologico e competenze digitali.
          </p>
          <p className="text-zinc-300 text-sm leading-relaxed mb-4">
            La piattaforma digitale e <span className="text-[#00FF41] font-bold">già operativa</span>. 
            Ora serve la sede: un capannone da riqualificare, 3 professionisti da compensare, e un fondo per partire.
          </p>
          <div className="text-center p-4 border border-[#00FF41]/20 bg-[#00FF41]/5 mt-6">
            <p className="text-zinc-500 text-[10px] font-mono uppercase mb-2">OBIETTIVO ANNUALE</p>
            <p className="text-4xl sm:text-5xl font-black text-[#00FF41]">{obiettivo.toLocaleString('it-IT')}</p>
            <p className="text-zinc-500 text-xs mt-1">tutto rendicontato, tutto trasparente</p>
          </div>
        </div>

        {/* I 5 Comuni */}
        <div style={fadeIn(2)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            I 5 COMUNI DELLA VALDELSA
          </p>
          <div className="space-y-2">
            {comuni.map((c, i) => (
              <div key={i} className="flex items-center justify-between p-4 border border-zinc-800 hover:border-zinc-600 transition-colors">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: c.colore }} />
                  <p className="text-white font-bold text-sm">{c.nome}</p>
                </div>
                <p className="text-zinc-500 font-mono text-xs">{c.pop} abitanti</p>
              </div>
            ))}
            <div className="flex items-center justify-between p-4 border-t-2 border-[#00FF41]/30 mt-2">
              <p className="text-[#00FF41] font-bold text-sm">TOTALE BACINO</p>
              <p className="text-[#00FF41] font-mono font-bold">{popTotale.toLocaleString('it-IT')} abitanti</p>
            </div>
          </div>

          <div className="mt-6 p-4 bg-[#0A0A0A] border border-[#FFD700]/20">
            <p className="text-[#FFD700] text-xs font-bold mb-2">Il calcolo che fa riflettere</p>
            <p className="text-zinc-400 text-xs leading-relaxed">
              Se anche solo <span className="text-white font-bold">l'1% della popolazione</span> donasse una media di 
              <span className="text-[#00FF41] font-bold"> 10 EUR</span>, raccoglieremmo 
              <span className="text-white font-bold"> 7.320 EUR</span> in un giorno.
              <br />Con il <span className="text-white font-bold">5%</span> e una media di 
              <span className="text-[#00FF41] font-bold"> 25 EUR</span>, arriviamo a 
              <span className="text-[#FFD700] font-bold"> 91.500 EUR</span> — più dell'obiettivo annuale.
            </p>
          </div>
        </div>

        {/* Tagli di donazione */}
        <div style={fadeIn(4)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            SCEGLI IL TUO CONTRIBUTO
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
            {tagli.map((t, i) => (
              <button
                key={i}
                data-testid={`donation-tier-${t.importo}`}
                onClick={() => setSelectedTaglio(t.importo)}
                className="relative p-5 border text-center transition-all duration-300 cursor-pointer group"
                style={{
                  borderColor: selectedTaglio === t.importo ? t.colore : '#333',
                  backgroundColor: selectedTaglio === t.importo ? `${t.colore}10` : '#0A0A0A',
                }}
              >
                <p className="text-2xl sm:text-3xl font-black" style={{ color: t.colore }}>
                  {t.importo}
                </p>
                <p className="text-zinc-500 text-[10px] font-mono mt-1">EUR</p>
                <p className="text-zinc-500 text-[10px] mt-2 group-hover:text-zinc-300 transition-colors">{t.desc}</p>
              </button>
            ))}
          </div>

          {selectedTaglio && (
            <div className="p-4 border border-[#00FF41]/30 bg-[#00FF41]/5 text-center animate-pulse">
              <p className="text-[#00FF41] text-sm font-bold">
                Hai scelto {selectedTaglio} EUR — Grazie!
              </p>
              <p className="text-zinc-400 text-xs mt-1">
                La funzione di pagamento sara attiva alla costituzione della Cooperativa.
              </p>
            </div>
          )}

          <Link to="/dona" 
                data-testid="go-to-dona-btn"
                className="block mt-4 text-center font-mono text-xs text-black bg-[#00FF41] py-3 hover:bg-[#33FF66] transition-colors">
            VAI AL SISTEMA DONAZIONI ATTIVO
          </Link>
        </div>

        {/* Per le aziende */}
        <div style={fadeIn(6)} className="mb-14 bg-[#0A0A0A] border border-[#FFD700]/20 p-6 sm:p-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#FFD700] mb-6">
            PER LE AZIENDE E LE BANCHE DEL TERRITORIO
          </p>
          <p className="text-zinc-300 text-sm leading-relaxed mb-6">
            Come Cooperativa Sociale iscritta al RUNTS (Ente del Terzo Settore), 
            le vostre donazioni godono di <span className="text-white font-bold">importanti agevolazioni fiscali</span>:
          </p>

          <div className="space-y-3 mb-6">
            <div className="border border-zinc-800 p-4">
              <p className="text-[#FFD700] font-bold text-sm mb-1">Imprese (IRES)</p>
              <p className="text-zinc-400 text-xs">
                Deducibilità fino al <span className="text-white font-bold">10% del reddito complessivo dichiarato</span>, 
                senza limite fisso. Eccedenze riportabili per 4 anni successivi.
                <br /><span className="text-zinc-500 text-[10px] font-mono">Art. 83 D.Lgs. 117/2017 (Codice Terzo Settore)</span>
              </p>
            </div>
            <div className="border border-zinc-800 p-4">
              <p className="text-[#00FF41] font-bold text-sm mb-1">Persone fisiche (IRPEF)</p>
              <p className="text-zinc-400 text-xs">
                <span className="text-white font-bold">Detrazione 30%</span> dell'importo donato, fino a 30.000 EUR di donazione.
                <br />Oppure <span className="text-white font-bold">deduzione fino al 10%</span> del reddito complessivo.
                <br /><span className="text-zinc-500 text-[10px] font-mono">Art. 83 D.Lgs. 117/2017</span>
              </p>
            </div>
            <div className="border border-zinc-800 p-4">
              <p className="text-purple-400 font-bold text-sm mb-1">Investitori in Impresa Sociale</p>
              <p className="text-zinc-400 text-xs">
                <span className="text-white font-bold">Detrazione IRPEF 30%</span> (max 1M/anno) o 
                <span className="text-white font-bold"> deduzione IRES 30%</span> (max 1,8M) per investimenti di almeno 5 anni.
                <br /><span className="text-zinc-500 text-[10px] font-mono">D.Lgs. 112/2017 — Impresa Sociale</span>
              </p>
            </div>
          </div>

          <div className="p-3 bg-[#FFD700]/5 border border-[#FFD700]/10 text-center">
            <p className="text-[#FFD700] text-xs font-bold">
              Ogni donazione deve essere tracciabile (bonifico bancario) e sara rendicontata con ricevuta fiscale.
            </p>
          </div>
        </div>

        {/* Come donare */}
        <div style={fadeIn(8)} className="mb-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">
            COME DONARE
          </p>
          <div className="space-y-3">
            {[
              { metodo: 'Bonifico Bancario', desc: 'C/C affiliato a Chianti Banca — IBAN comunicato alla costituzione', icon: 'B', status: 'IN ARRIVO' },
              { metodo: 'PayPal', desc: 'Gateway attivo sulla piattaforma /dona', icon: 'P', status: 'ATTIVO (Sandbox)' },
              { metodo: 'Carta di Credito / Stripe', desc: 'Pagamento sicuro via piattaforma', icon: 'S', status: 'PROSSIMAMENTE' },
              { metodo: 'Satispay / SMS Solidale', desc: 'Donazione veloce da smartphone', icon: 'M', status: 'IN VALUTAZIONE' },
              { metodo: 'CrowdFundMe / GoFundMe', desc: 'Campagna su piattaforma certificata di crowdfunding', icon: 'C', status: 'IN PREPARAZIONE' },
            ].map((m, i) => (
              <div key={i} className="flex items-center gap-4 p-4 border border-zinc-800">
                <div className="w-10 h-10 flex items-center justify-center bg-zinc-900 border border-zinc-700 font-mono text-[#00FF41] font-bold text-sm flex-shrink-0">
                  {m.icon}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 flex-wrap">
                    <p className="text-white font-bold text-sm">{m.metodo}</p>
                    <span className="text-[10px] font-mono px-2 py-0.5 border border-zinc-700 text-zinc-500">{m.status}</span>
                  </div>
                  <p className="text-zinc-500 text-xs mt-1">{m.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Dove vanno i soldi */}
        <div style={fadeIn(10)} className="mb-14 bg-[#0A0A0A] border border-[#00FF41]/20 p-6 sm:p-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6 text-center">
            DOVE VANNO I VOSTRI SOLDI — TRASPARENZA TOTALE
          </p>
          <div className="space-y-3">
            {[
              { voce: 'Maieuta + Corsi + Coaching', importo: '22.250', perc: 25.1 },
              { voce: 'AI Expert / Sales Manager + Corsi', importo: '22.250', perc: 25.1 },
              { voce: 'Psicologo (team + sportello Mentor)', importo: '10.750', perc: 12.1 },
              { voce: 'Sede: affitto, utenze, manutenzione', importo: '15.000', perc: 16.9 },
              { voce: 'Riqualificazione capannone (Anno 1)', importo: '15.500', perc: 17.5 },
              { voce: 'Fondo emergenza', importo: '3.000', perc: 3.4 },
            ].map((v, i) => (
              <div key={i}>
                <div className="flex justify-between text-xs mb-1">
                  <span className="text-zinc-300">{v.voce}</span>
                  <span className="text-[#00FF41] font-mono font-bold">{v.importo} EUR</span>
                </div>
                <div className="w-full h-2 bg-zinc-900 overflow-hidden">
                  <div className="h-full bg-[#00FF41]/40" style={{ width: `${v.perc}%` }} />
                </div>
              </div>
            ))}
            <div className="flex justify-between pt-3 border-t border-[#00FF41]/20">
              <span className="text-[#00FF41] font-bold text-sm">TOTALE</span>
              <span className="text-[#00FF41] font-mono font-bold">88.750 EUR</span>
            </div>
          </div>
        </div>

        {/* Appello */}
        <div style={fadeIn(12)} className="mb-14 text-center">
          <div className="w-16 h-[1px] bg-[#00FF41]/30 mx-auto mb-8" />
          <p className="text-2xl sm:text-3xl font-black text-white mb-4">
            Non servono milioni.
          </p>
          <p className="text-xl text-zinc-400 mb-2">
            Servono <span className="text-[#00FF41] font-bold">migliaia di persone</span> che credono
          </p>
          <p className="text-xl text-zinc-400 mb-6">
            che il proprio territorio meriti di piu.
          </p>
          <p className="text-zinc-500 text-sm max-w-md mx-auto leading-relaxed">
            L'Europa ha stanziato miliardi. La Regione ha i fondi. Le banche hanno gli utili.
            Ma se nessuno si muove, lo facciamo noi — dal basso, come sempre.
          </p>
        </div>

        {/* CTA condivisione */}
        <div style={fadeIn(14)} className="mb-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <Link to="/dona" className="block text-center font-mono text-xs text-black bg-[#00FF41] py-4 hover:bg-[#33FF66] transition-colors">
              DONA ORA
            </Link>
            <Link to="/strategia" className="block text-center font-mono text-xs text-[#FFD700] border border-[#FFD700]/30 py-4 hover:bg-[#FFD700]/10 transition-colors">
              LEGGI LA STRATEGIA COMPLETA
            </Link>
            <Link to="/chiantibanca" className="block text-center font-mono text-xs text-white border border-zinc-600 py-4 hover:bg-zinc-800 transition-colors">
              PROPOSTA CHIANTIBANCA
            </Link>
            <Link to="/angels" className="block text-center font-mono text-xs text-purple-400 border border-purple-500/30 py-4 hover:bg-purple-500/10 transition-colors">
              MANIFESTO BUSINESS ANGEL
            </Link>
          </div>
        </div>

        {/* Footer */}
        <div style={fadeIn(15)} className="text-center text-zinc-600 text-xs border-t border-zinc-900 pt-8 pb-4">
          <p className="text-zinc-500 font-mono text-[10px] mb-2">
            &lt;/AI_COVO.tech&gt;® — Campagna Crowdfunding Territoriale
          </p>
          <p>Colle Val d'Elsa · Poggibonsi · San Gimignano · Casole d'Elsa · Monteriggioni</p>
          <p className="text-zinc-700 mt-1">Valdelsa — Toscana — Italia</p>
        </div>

      </div>
    </main>
  );
};

export default CrowdfundingPage;
